import { createContext, useContext, useState } from 'react';

// Create context for header state
const HeaderContext = createContext({
  useBlurredBackground: false,
  setUseBlurredBackground: () => {}
});

// Custom hook to use the header context
export const useHeader = () => useContext(HeaderContext);

// Provider component
export function HeaderProvider({ children }) {
  const [useBlurredBackground, setUseBlurredBackground] = useState(false);

  const contextValue = {
    useBlurredBackground,
    setUseBlurredBackground
  };

  return (
    <HeaderContext.Provider value={contextValue}>
      {children}
    </HeaderContext.Provider>
  );
}
